import React, { FunctionComponent } from 'react';

import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

import { DateBlockOneContainer } from '../../date/date-block-one-container';
import { DateBlockTwoContainer } from '../../date/date-block-two-container';
import { DateHeroBlockContainer } from '../../date/date-hero-block-container';

export const DateContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <DateHeroBlockContainer />
        <DateBlockOneContainer />
        <DateBlockTwoContainer />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
